import { APP, reducer as appReducer } from './app';
import { USER, reducer as userReducer } from './user';
import { PROJECTS, reducer as projectsReducer } from './projects';
import { TIMELINE, reducer as timelineReducer } from './timeline';
import { TASKS, reducer as tasksReducer } from './tasks';
import { COLLABORATORS, reducer as collabReducer } from './collaborators';

export default {
  [APP]: appReducer,
  [USER]: userReducer,
  [PROJECTS]: projectsReducer,
  [TIMELINE]: timelineReducer,
  [TASKS]: tasksReducer,
  [COLLABORATORS]: collabReducer
};



// WEBPACK FOOTER //
// ./src/redux/reducers.js